/* __next_internal_client_entry_do_not_use__ MarketplaceProductBrandLinkBase auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { handleGenerateBrandUrl } from "@faire/retailer-visitor-shared/components/SearchProducts/utils";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { useGetProductTileClickImpressions } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/productTileActions/useGetProductTileClickImpressions";
import { MarketplaceProductBrandLink } from "@faire/retailer-visitor-shared/features/MarketplaceItems/MarketplaceProductBrandLink";
import * as RetailerPaths from "@faire/retailer-visitor-shared/paths/index";
import { useSearchPageProductSearchString } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageProductSearchString";
import { trackProductTileBrandLinkHover } from "@faire/web-api--source/events/productTile/hover/brandLink";
import React, { useCallback, useMemo } from "react";
/**
 * Component used for non-rsc branch brand link on discovery tile
 */ export var MarketplaceProductBrandLinkBase = function(param) {
    var brandToken = param.brandToken, children = param.children, onBrandLinkClick = param.onBrandLinkClick, generateBrandUrl = param.generateBrandUrl;
    var trackingParamsBrandClickHandler = useOnBrandClickSearchPage();
    var onBrandClick = useCallback(function(ev) {
        if (onBrandLinkClick) {
            onBrandLinkClick(ev);
        } else {
            trackingParamsBrandClickHandler.onBrandClick(ev);
        }
    }, [
        trackingParamsBrandClickHandler,
        onBrandLinkClick
    ]);
    var onBrandLinkHover = useCallback(function() {
        trackProductTileBrandLinkHover();
    }, []);
    var onBrandLinkMouseEnter = useCallback(function() {
        trackProductTileBrandLinkHover();
    }, []);
    var queryString = useSearchPageProductSearchString();
    var generateBrandUrlDefault = handleGenerateBrandUrl(queryString, {
        brandToken: brandToken,
        productToken: undefined,
        impressionId: undefined
    });
    var generateBrandUrlFn = generateBrandUrl !== null && generateBrandUrl !== void 0 ? generateBrandUrl : generateBrandUrlDefault;
    var brandUrl = useMemo(function() {
        if (!brandToken) {
            return undefined;
        }
        if (!generateBrandUrlFn) {
            return RetailerPaths.brandPage(brandToken);
        }
        return generateBrandUrlFn(brandToken);
    }, [
        brandToken,
        generateBrandUrlFn
    ]);
    return /*#__PURE__*/ _jsx(MarketplaceProductBrandLink, {
        token: brandToken,
        onClick: function(ev) {
            onBrandClick === null || onBrandClick === void 0 ? void 0 : onBrandClick(ev);
        },
        onMouseEnter: onBrandLinkHover,
        onTouchStart: onBrandLinkMouseEnter,
        "data-test-id": "marketplace-product-brand-link",
        to: brandUrl,
        children: children
    });
};
var useOnBrandClickSearchPage = function() {
    var recordBrandNameClickEvent = useGetProductTileClickImpressions({}).recordBrandNameClickEvent;
    return {
        onBrandClick: function(event) {
            recordBrandNameClickEvent();
            event.stopPropagation();
        }
    };
};
